import { Injectable } from '@angular/core';

import { AuthService } from "../../../shared/services/auth.service";
import {gruposMateriaisRouter, subgruposMateriaisRouter} from "./data.service";
import { newRoute, editRoute } from "../../../shared/services/data.service";
import { almoxarifadoRoute } from "../../shared/data.service";

@Injectable()
export class GrupoMaterialNavigationService {

  constructor(
    private _authService: AuthService
  ) { }

  goToList() {
    var router: string = almoxarifadoRoute + '/' + gruposMateriaisRouter;
    this._authService.navigateTo(router);
  }

  goToNew() {
    var router: string = almoxarifadoRoute + '/' + gruposMateriaisRouter + '/' + newRoute;
    this._authService.navigateTo(router);
  }

  goToEdit(objectId: number) {
    var router: string = almoxarifadoRoute + '/' + gruposMateriaisRouter + '/' + editRoute;
    this._authService.navigateTo(router, objectId);
  }

  //subgrupos
  goToAddSubgrupo(grupoId: number) {
    var router: string = almoxarifadoRoute + '/' + gruposMateriaisRouter + '/' + subgruposMateriaisRouter + '/' + newRoute;
    this._authService.navigateTo(router, grupoId);
  }

  goToEditSubgrupo(grupoId: number, objectId: number) {
    var router: string = almoxarifadoRoute + '/' + gruposMateriaisRouter + '/' + subgruposMateriaisRouter + '/' + editRoute;
    this._authService.navigateTo(router, [grupoId, objectId]);
  }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/almoxarifado/grupos-materiais/shared/grupo-material-navigation.service.ts
 **/